import { Dropdown, Pagination, Space, Tooltip } from "antd";
import React, { useState } from "react";
import { AiTwotoneSetting } from "react-icons/ai";
import {
  FaEllipsisV,
  FaFileAlt,
  FaInfoCircle,
  FaMoneyCheckAlt,
  FaTrashRestoreAlt,
  FaWindowClose,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { formatDate, useDelete } from "../../../../../utils/CustomFunctions";
import Alert from "../../../../global/alert/Alert";
import { IoCloseSharp } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import ApproveModel from "./ApproveModel";
import CancelModel from "./CancelModel";

export const Table = ({ payout_request }) => {
  const [openModel2, setOpenModel2] = useState(false);
  const [openModel, setOpenModel] = useState(false);
  const [modelApprove, setModelApprove] = useState("");
  const [modelCancelRequest, setModelCancelRequest] = useState({
    id: "",
    reason: "",
  });
  // this is alert maessage
  const msg = {
    icon: <FaInfoCircle className="me-3" />,
    type: "alert-info",
    text: "No payout request found",
  };

  const handleOderApprove = (e, id) => {
    e.preventDefault();
    setModelApprove(id);
    setOpenModel2(true);
  };
  const handleOderCancel = (e, id) => {
    e.preventDefault();
    setModelCancelRequest({ ...modelCancelRequest, id });
    setOpenModel(true);
  };

  const { isLoading, handleDelete } = useDelete(
    "admin",
    "payout_method_requests",
    "payout_requests"
  );

  // for pagination purposes
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const indexOfLastData = currentPage * itemsPerPage;
  const indexOfFirstData = indexOfLastData - itemsPerPage;
  const currentData = payout_request?.slice(indexOfFirstData, indexOfLastData);

  return (
    <>
      <ApproveModel
        openModel={openModel2}
        setOpenModel={setOpenModel2}
        id={modelApprove}
      />
      <CancelModel
        openModel={openModel}
        setOpenModel={setOpenModel}
        request={modelCancelRequest}
        setrequest={setModelCancelRequest}
      />
      <div className="row organizer-event">
        <div className="col-12">
          {payout_request && payout_request.length > 0 ? (
            <div className="card">
              <div className="table-responsive">
                <table className="table table-hover table-vcenter">
                  <thead>
                    <tr>
                      <th className="text-center">Reference</th>
                      <th>Event date</th>
                      <th>Organizer</th>
                      <th>Payout method </th>
                      <th>Net sales</th>
                      <th>Request date</th>
                      <th>Status</th>
                      <th className="text-center">
                        <AiTwotoneSetting />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.map((request, index) => {
                      const items = [
                        {
                          label: (
                            <Link
                              to={`${request?.reference}/details`}
                              className="d-flex align-items-center"
                            >
                              <FaFileAlt className="me-1" />
                              Details
                            </Link>
                          ),
                          key: "0",
                        },
                        request?.status === "pending" && {
                          label: (
                            <Link
                              to=""
                              onClick={(e) => handleOderApprove(e, request.id)}
                              className="d-flex align-items-center"
                            >
                              <FaMoneyCheckAlt className="me-1" />
                              Approve
                            </Link>
                          ),
                          key: "1",
                        },
                        request?.status === "pending" && {
                          label: (
                            <Link
                              to=""
                              onClick={(e) => handleOderCancel(e, request.id)}
                              className="d-flex align-items-center"
                            >
                              <FaWindowClose className="me-1" />
                              Cancel
                            </Link>
                          ),
                          key: "2",
                        },
                        {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(
                                  e,
                                  request?.id,
                                  "payout_method_request_delete",
                                  ""
                                )
                              }
                            >
                              {request.deleted_at !== null ? (
                                <>
                                  <FaTrashRestoreAlt className="me-1" /> Restore
                                </>
                              ) : (
                                <>
                                  <IoCloseSharp className="me-1" />
                                  Delete
                                </>
                              )}
                            </Link>
                          ),
                          key: "5",
                        },
                        request.deleted_at && {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(
                                  e,
                                  request?.id,
                                  "payout_method_request_permanent_delete",
                                  "delete_permanent"
                                )
                              }
                            >
                              <MdDelete className="me-1" />
                              Delete permanently
                            </Link>
                          ),
                          key: "6",
                        },
                      ];
                      return (
                        <tr key={index}>
                          <td className="text-center text-muted text-sm">
                            {request?.reference}
                          </td>
                          <td className="text-sm">
                            {request?.event?.name}
                            <br />
                            {
                              formatDate(new Date(request?.event?.start_On))
                                .fullDate
                            }
                          </td>
                          <td>{request?.user?.organize_name}</td>
                          <td>
                            {request?.payout_method === "stripe" ? (
                              <img
                                src="/./images/strip.svg"
                                className="img-thumbnail img-50-50"
                              />
                            ) : (
                              <img
                                src="/./images/paypal.svg"
                                className="img-thumbnail img-50-50"
                              />
                            )}
                          </td>
                          <td>${request?.net_sales}</td>

                          <td>
                            {
                              formatDate(new Date(request?.request_date))
                                .fullDate
                            }
                          </td>
                          <td className="">
                            {request?.status === "pending" && (
                              <span className="badge badge-warning ">
                                Pending
                              </span>
                            )}
                            {request?.status === "cancel" && (
                              <span className="badge badge-danger ">
                                Canceled
                              </span>
                            )}
                            {request?.status === "approve" && (
                              <span className="badge badge-success ">
                                Approved
                              </span>
                            )}
                            {request?.deleted_at && (
                              <>
                                <br />
                                <br />
                                <span className="badge badge-danger d-inline-flex align-items-center">
                                  <IoCloseSharp className="me-1" />
                                  Deleted
                                </span>
                              </>
                            )}
                          </td>
                          <td className="text-center">
                            <Dropdown
                              menu={{
                                items,
                              }}
                              trigger={["click"]}
                            >
                              <a onClick={(e) => e.preventDefault()}>
                                <Space className="justify-content-center">
                                  <FaEllipsisV />
                                </Space>
                              </a>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <Alert {...msg} />
          )}
        </div>
      </div>

      {payout_request?.length > 10 && (
        <Pagination
          current={currentPage}
          total={payout_request.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
        />
      )}
    </>
  );
};
